import { useEffect, useState } from "react";

/**
 * VORÜBERGEHENDE Messhilfe für In-App-Browser (z. B. die Google-App auf dem
 * iPhone, die eigene Leisten über die Seite legt). Erscheint nur, wenn die
 * Seite mit ?debug=viewport geöffnet wird, und gilt dann bis zum Neuladen.
 * Speichert nichts. Vor dem Livegang entfernen (siehe TODO.md).
 */
const ACTIVE =
  typeof window !== "undefined" &&
  new URLSearchParams(window.location.search).get("debug") === "viewport";

// Misst eine CSS-Höhe in Pixeln, z. B. 100lvh oder env(safe-area-inset-top).
const probe = (height) => {
  const el = document.createElement("div");
  el.style.cssText = `position:fixed;left:0;top:0;width:0;visibility:hidden;height:${height}`;
  document.body.appendChild(el);
  const px = Math.round(el.getBoundingClientRect().height);
  el.remove();
  return px;
};

const browserName = () => {
  const ua = navigator.userAgent;
  if (/GSA\//.test(ua)) return "Google-App";
  if (/CriOS/.test(ua)) return "Chrome";
  if (/FxiOS/.test(ua)) return "Firefox";
  if (/Instagram|FBAN|FBAV/.test(ua)) return "Instagram/Facebook";
  if (/Safari/.test(ua)) return "Safari o. a.";
  return "unbekannt";
};

export const ViewportDebug = () => {
  const [values, setValues] = useState(null);

  useEffect(() => {
    if (!ACTIVE) return undefined;
    const read = () => {
      const vv = window.visualViewport;
      const header = document.querySelector('[data-testid="top-navbar"]');
      const hero = document.querySelector("#top");
      setValues({
        Browser: browserName(),
        Fenster: `${window.innerWidth} × ${window.innerHeight}`,
        Client: document.documentElement.clientHeight,
        Sichtbar: vv
          ? `${Math.round(vv.height)} hoch, oben ${Math.round(vv.offsetTop)}, Seite ${Math.round(vv.pageTop)}`
          : "-",
        Scroll: Math.round(window.scrollY),
        Leiste: header ? Math.round(header.getBoundingClientRect().top) : "-",
        Seitenkopf: hero ? Math.round(hero.getBoundingClientRect().top) : "-",
        Einheiten: `vh ${probe("100vh")} · svh ${probe("100svh")} · lvh ${probe("100lvh")} · dvh ${probe("100dvh")}`,
        "Safe Area": `oben ${probe("env(safe-area-inset-top)")} · unten ${probe("env(safe-area-inset-bottom)")}`,
        Bildschirm: `${window.screen.width} × ${window.screen.height} @${window.devicePixelRatio}`,
      });
    };
    read();
    const vv = window.visualViewport;
    window.addEventListener("scroll", read, { passive: true });
    window.addEventListener("resize", read);
    vv?.addEventListener("resize", read);
    vv?.addEventListener("scroll", read);
    return () => {
      window.removeEventListener("scroll", read);
      window.removeEventListener("resize", read);
      vv?.removeEventListener("resize", read);
      vv?.removeEventListener("scroll", read);
    };
  }, []);

  if (!ACTIVE || !values) return null;

  return (
    <div className="fixed left-2 top-[30%] z-[200] max-w-[17rem] rounded-lg border border-white/25 bg-black/85 p-2.5 font-mono text-[11px] leading-snug text-white pointer-events-none">
      {Object.entries(values).map(([key, value]) => (
        <div key={key}>
          <span className="text-white/50">{key}:</span> {value}
        </div>
      ))}
    </div>
  );
};
